@if (formControl()) {
<div class="textarea form-group">
    <mat-form-field class="form-field">
        <textarea class="area" matInput [rows]="meta().rows" [ngStyle]="textStyle" [placeholder]="meta().name"
            [formControl]="formControl()!" [readonly]="readonly()" (change)="onChange($event)"></textarea>
        @if (formControl()?.value && !readonly()) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="formControl()?.setValue('')">
            <mat-icon>close</mat-icon>
        </button>
        }
        <mat-hint><strong>{{meta().info}}</strong></mat-hint>
        @if (formControl()?.hasError('required')) {
        <mat-error>
            {{meta().name}} is <strong>required</strong>
        </mat-error>
        }
        @if (formControl()?.hasError('form')) {
        <mat-error>
            {{formError}}
        </mat-error>
        }
    </mat-form-field>
</div>
}
